import { PagerParams, PagerResponse } from 'src/app/core/dtos';
import { BillOnType } from '../../common/common/common.proto';

export enum BillToType {
  BILL_TO_TYPE_UNSET = 'BILL_TO_TYPE_UNSET',
  BILL_TO_OXIO_SUPPORT = 'BILL_TO_OXIO_SUPPORT',
  BILL_TO_OXIO_OUTAGE = 'BILL_TO_OXIO_OUTAGE',
  BILL_TO_OXIO_INTERNAL = 'BILL_TO_OXIO_INTERNAL',
  BILL_TO_OXIO_MARKETING = 'BILL_TO_OXIO_MARKETING',
  BILL_TO_BRAND_PURCHASE = 'BILL_TO_BRAND_PURCHASE',
  BILL_TO_BRAND_SUPPORT = 'BILL_TO_BRAND_SUPPORT',
  BILL_TO_BRAND_MARKETING = 'BILL_TO_BRAND_MARKETING',
  BILL_TO_OTHER = 'BILL_TO_OTHER',
}

export enum BillToAccountStatus {
  BILLING_ACCOUNT_STATUS_UNSET = 'BILLING_ACCOUNT_STATUS_UNSET',
  BILLING_ACCOUNT_ACTIVATED = 'BILLING_ACCOUNT_ACTIVATED',
  BILLING_ACCOUNT_TERMINATED = 'BILLING_ACCOUNT_TERMINATED',
}

export interface GetBrandBillingConfigParams {
  brandId?: string;
}

export interface GetBrandBillingConfigResponse {
  brandId: string;
  billOn: BillOnType;
  billToAccountId: string;
}

export interface SetBrandBillingConfigParams {
  brandId: string;
  billOn: BillOnType;
  billToAccountId: string;
}

export interface SetBrandBillingConfigResponse {
  success: boolean;
}

export interface BillToAccounts {
  billToAccountId: string;
  type?: BillToType;
  brandId?: string;
  name: string;
  status?: BillToAccountStatus;
}

export interface GetBillToAccountsParams extends PagerParams {
  brandIds: string[];
}

export interface GetBillToAccountsResponse extends PagerResponse {
  billToAccounts: BillToAccounts[];
}

// FE interface
export interface BillToAccountsMap {
  [key: string]: BillToAccounts;
}
